import React, { useState, useContext, useEffect, useRef } from 'react';
import { useSpring, animated } from 'react-spring';
import { v4 as uuidv4 } from 'uuid';

import { FileUploaderButton } from '../../Components/FileUploaderButton';
import { FormTextInput } from '../../Components/FormTextInput';
import { languages } from '../../Data/languages';
import { useScreenTransition } from '../../Hooks/useScreenTransition';
import { useEnterKey } from '../../Hooks/useEnterKey';
import { AuthContext } from '../../Context/AuthContext';
import { NotificationContext } from '../../Context/NotificationContext';
import { DataContext } from '../../Context/DataContext';


import TopBar from '../../Components/TopBar';
import LogoAuthNavbar from '../../NewComponents/LogoAuthNavbar';
import CreateOrderNav from '../../NewComponents/CreateOrderNav';
import SearchSelect from '../../NewComponents/SearchSelect';
import NewButton from '../../NewComponents/NewButton';
import SecureAndPrivate from '../../NewComponents/SecureAndPrivate';
import OrderSummary from './components/OrderSummary';

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/highlight/lib/styles/index.css";
import './OrderDocuments.css';
import AddCommentonDocument from '../../NewComponents/AddComment/AddCommentonDocument';
import { firestore, storage } from '../../firebase.config';
import { gTagDocumentUploadEvent } from '../../Data/Functions/gTAgEvents';

const OrderDocuments = ({ windowSize }) => {

  const { transitionTo } = useScreenTransition();
  const { showNotification } = useContext(NotificationContext);
  const { signedIn } = useContext(AuthContext);
  const { order, setOrder, userData, teamData } = useContext(DataContext);
  const [selectedFile, setSelectedFile] = useState(null);

  const [addComment, showAddComment] = useState(false);

  const [certified, setCertified] = useState(true);
  const [languageFrom, setLanguageFrom] = useState('');
  const [languageTo, setLanguageTo] = useState('');
  const certifiedProps = useSpring({ borderColor: certified ? '#12ABBF' : '#E6E7E9' });
  const standardProps = useSpring({ borderColor: !certified ? '#12ABBF' : '#E6E7E9' });
  const [files, setFiles] = useState([]);

  const [pagesCount, setPagesCount] = useState('');
  const [generalNote, setGeneralNote] = useState('');
  const [discount, setDiscount] = useState(0);
  const now = new Date();
  const [focus, setFocus] = useState({
    languageFrom: false,
    languageTo: false,
  });


  useEffect(() => {
    if (order.parsed && (!order.type || order.type === '')) {
      transitionTo('/order/type');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order]);

  useEffect(() => {
    if ((windowSize.width > 767 || windowSize.orientation === 'landscape') && document.getElementById('mainPrimary') && document.getElementById('mainSecondary')) {
      if (document.getElementById('mainPrimary').clientHeight > document.getElementById('mainSecondary').clientHeight) {
        document.getElementById('mainSecondary').style.minHeight = `${document.getElementById('mainPrimary').clientHeight}px`;
      } else {
        document.getElementById('mainPrimary').style.minHeight = `${document.getElementById('mainSecondary').clientHeight}px`;
      }
    }
  });

  const updateOrderId = () => {
    const id = uuidv4();
    setOrder(o => ({ ...o, orderID: id }));
    return id;
  }

  useEffect(() => {

    if(order && order.parsed){
      setCertified(order.certified === false ? order.certified : true);
      setLanguageFrom(order.languageFrom || '');
      setLanguageTo(order.languageTo || '');
      setFiles(order.files || []);
      setPagesCount(order.pagesCount || '');
      setGeneralNote(order.generalNotes || '');

      if(!order.orderID || order.orderID === '') {
        updateOrderId();
      }

      if(order.orderID){
        firestore.collection("orders").doc(order.orderID).get().then((doc) => {
          if(doc.exists && doc.data().status !== "created"){
            updateOrderId();
          }
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps  
  }, [order]);

console.log(order, "order")
  useEffect(() => {
    if(order.parsed){
      if(order.discount && order.discount > 0){
        setDiscount(order.discount);
      }else if(userData && userData.teamId && teamData && teamData.discount && teamData.discount > 0){
        setDiscount(teamData.discount);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, teamData, order]);

  useEffect(() => {
    if(languageFrom !== "" && languageFrom !== "english" && languageTo === ""){
      setLanguageTo("english");
    }
  }, [languageFrom])

    
  const handleFiles = async (e) => {
    const mFiles = e.target.files;

    if(files.length === 0 && mFiles.length > 0){
      gTagDocumentUploadEvent();
    }


    const oID = !order.orderID || order.orderID === '' ? updateOrderId() : order.orderID;


    for (let i = 0; i < mFiles.length; i++) {
      const fileID = uuidv4();
      setFiles(f => f.concat([{ id: fileID, name: mFiles[i].name, file: mFiles[i], progress: 0, status: 'uploading' }]));
    }

    const storageRef = storage.ref();

    for (let i = 0; i < mFiles.length; i++) {
      const subFolder = uuidv4();
      const fileRef = storageRef.child(oID + '/' + subFolder + '/' + mFiles[i].name);

      const downloadToken = uuidv4();

      const fileName = mFiles[i].name.replace('#', '%23').replace('+', "%2b");

      const url = `${process.env.REACT_APP_STORAGE_URL}/o/${oID}%2F${subFolder}%2F${fileName}?alt=media&token=${downloadToken}`;

      var metadata = {
        firebaseStorageDownloadTokens: downloadToken,
        customMetadata: {
          'orderID': oID
        }
      }

      const uploadTask = fileRef.put(mFiles[i], metadata);

      setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, task: uploadTask } : file));

      uploadTask.on('state_changed', (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, progress: progress.toFixed(2) } : file));
      }, (error) => {
        // setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'failed' } : file));
        setFiles(f => f.filter(file => file.name !== mFiles[i].name && file.ref !== mFiles[i].ref));
        showNotification("Error uploading.", "There was an error uploading the file " + mFiles[i].name + ". Please, try again.", "error");
      }, () => {
        setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'complete', ref: oID + '/' + subFolder + '/' + mFiles[i].name, url: url, timestamp: now.getTime() } : file));
      })
    }

  }



  const handleDeleteFile = async (file) => {
    const checkFile = (file1, file2) => {
      if(file1.id && file2.id){
        return file1.id === file2.id;
      }
      if(file1.ref && file2.ref){
        return file1.ref === file2.ref;
      }
    }
    const storageRef = storage.ref();

    if (file.ref && (file.status === "complete" || file.timestamp)) {
      const fileRef = storageRef.child(file.ref);
      setFiles((f) =>
        f.map((mFile) =>
          mFile.name === file.name && checkFile(mFile, file)
            ? { ...mFile, status: "deleting" }
            : mFile
        )
      );

      fileRef
        .delete()
        .then(function () {
          setFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
        })
        .catch(function (error) {
          showNotification(
            "Error deleting the file.",
            "There was an error deleting the file " +
              file.name +
              ". Please, try again.",
            "error"
          );
        });
    } else if (file.status === "failed") {
      setFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
    } else {
      file.task.cancel();
      setFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
    }
  };

  const handleContinueToOptions = () => {
    const orderId = !order.orderID || order.orderID === '' ? updateOrderId() : order.orderID;
    localStorage.setItem('order', JSON.stringify({ ...order, orderID: orderId, discount: discount, generalNotes: generalNote, certified: certified, languageFrom: languageFrom, languageTo: languageTo, files: JSON.stringify(files.filter(f => f.ref && f.url && f.status === 'complete').map(file => ({ name: file.name, id: file.id, ref: file.ref, url: file.url, type: 'source', size: file.file ? file.file.size : file.size, format: file.file ? file.file.type : file.format, status: 'complete', progress: 100, timestamp: file.timestamp }))), pagesCount: pagesCount }));
    setOrder(o => ({ ...o, orderID: orderId, discount: discount, generalNotes: generalNote, certified: certified, languageFrom: languageFrom, languageTo: languageTo, files: files.filter(f => f.ref && f.url && f.status === 'complete').map(file => ({ name: file.name, ref: file.ref, url: file.url, type: 'source', id: file.id, size: file.file ? file.file.size : file.size, format: file.file ? file.file.type : file.format, status: 'complete', progress: 100, timestamp: file.timestamp })), pagesCount: pagesCount }));
    transitionTo('/order/options');
  }

  const onChangePagesCount = (count) => {
    var reg = /^[0-9]+\.?[0-9]{0,3}$/;

    if (count === '' || reg.test(count)) {
      setPagesCount(count);
    }
  }

  const triggerContinue = () => {
    if (!((!signedIn && !order.name) || languageFrom === '' || languageTo === '' || files.length === 0 || (certified && pagesCount === '') || (pagesCount === '') || (!certified && pagesCount === '') || files.some(file => file.status !== 'complete'))) {
      handleContinueToOptions();
    }
  }

  useEnterKey(() => triggerContinue());

  const phoneScreen = windowSize.orientation === 'portrait' && windowSize.width <= 767;

  const handleFocusLanguageFrom = (isFocused) => {
    setFocus({ languageFrom: isFocused, languageTo: false });
  };

  const handleFocusLanguageTo = (isFocused) => {
    setFocus({ languageFrom: false, languageTo: isFocused });
  };

  const handleAddComment = (file) => {
    setSelectedFile(file);
    showAddComment(true);
  };

  const handleAddCommentClose = () => {
    showAddComment(false);
    setSelectedFile(null);
  };

  const handleSetTraslationType = (isCertified) => {
    setCertified(isCertified);

    const orderId = !order.orderID || order.orderID === '' ? updateOrderId() : order.orderID;
    localStorage.setItem('order', JSON.stringify({ type: order.type, parsed: true, orderID: orderId, discount: discount, generalNotes: generalNote, certified: isCertified, languageFrom: languageFrom, languageTo: languageTo, files: JSON.stringify(files.filter(f => f.ref && f.url && f.status === 'complete').map(file => ({ name: file.name, id: file.id, ref: file.ref, url: file.url, type: 'source', size: file.file ? file.file.size : file.size, format: file.file ? file.file.type : file.format, status: 'complete', progress: 100, timestamp: file.timestamp }))), pagesCount: pagesCount }));
    setOrder(o => ({ type: order.type, parsed: true, orderID: orderId, discount: discount, generalNotes: generalNote, certified: isCertified, languageFrom: languageFrom, languageTo: languageTo, files: files.filter(f => f.ref && f.url && f.status === 'complete').map(file => ({ name: file.name, ref: file.ref, url: file.url, type: 'source', id: file.id, size: file.file ? file.file.size : file.size, format: file.file ? file.file.type : file.format, status: 'complete', progress: 100, timestamp: file.timestamp })), pagesCount: pagesCount }));
  
  }


  return (
    <>
      <TopBar />
      <div className="mainOrderContainer">
        {!addComment &&
          <div className="mainOrderHeader">
            <LogoAuthNavbar isAuth={signedIn} showButtons={false} />
          </div>
        }
        {
          !addComment &&
          <div className="mainOrderPageContainer">
            <div className="mainOrderPageContainerOptions">
              <CreateOrderNav title="2. Details" stage={2} />
              <div></div>
            </div>
          </div>
        }
        {addComment && (
          <AddCommentonDocument selectedFile={selectedFile} handleClose={handleAddCommentClose} />
        )}
        {
          !addComment &&
          <div className="mainOrderPageContainer">
            <div className="mainOrderPageContainerOptions">
              <div id="mainPrimary" className='mainOrderPrimaryContent'>
                <div className='quotePrimaryOptionsWrapper'>
                  <h4 className="quotePrimaryTitle">What type of translation do you need?</h4>
                  <div className="quotePrimaryOptions">
                    <animated.div style={certifiedProps} className="quotePrimaryOption" onClick={() => handleSetTraslationType(true)}>
                      <div className='quotePrimaryOptionTitleWrap'>
                        <p className="quotePrimaryOptionTitle">Certified Translation</p>
                        <p className="quotePrimaryOptionTitle">$24.95/page</p>
                      </div>
                      <p className="quotePrimaryOptionText">Includes our certification for official use with legal and institutional entities, such as USCIS, courts, and universities.</p>
                    </animated.div>
                    <animated.div style={standardProps} className="quotePrimaryOption" onClick={() => handleSetTraslationType(false)}>
                      <div className='quotePrimaryOptionTitleWrap'>
                        <p className="quotePrimaryOptionTitle">Standard Translation</p>
                        <p className="quotePrimaryOptionTitle">$24.95/page</p>
                      </div>
                      <p className="quotePrimaryOptionText">For business and personal purposes, including CVs, client intake forms, and marketing materials for your business.</p>
                    </animated.div>
                  </div>
                </div>

                <div className='quotePrimaryOptionsWrapper'>
                  <h4 className="quotePrimaryTitle">What language pair do you need translated?</h4>
                  <p className="quoteSmallMessage">Either the source or target language must include English. Please contact us for language pairs without English.</p>
                  <div className="quoteDetailsInputsContainer">
                    <SearchSelect
                      list={languages.filter(language => languageTo === 'english' || languageTo === '' || language.value === 'english')}
                      placeholder="From"
                      value={languageFrom}
                      focus={focus.languageFrom}
                      setValue={setLanguageFrom}
                      setFocus={handleFocusLanguageFrom}
                    />
                    <SearchSelect
                      list={languages.filter(language => languageFrom === 'english' || languageFrom === '' || language.value === 'english')}
                      placeholder="To"
                      value={languageTo}
                      focus={focus.languageTo}
                      setValue={setLanguageTo}
                      setFocus={handleFocusLanguageTo}
                    />
                  </div>
                </div>

                <div className='quotePrimaryOptionsWrapper'>
                  <h4 className="quotePrimaryTitle">How many pages do you need translated?</h4>

                  <div className="orderCountContainer">
                    <p className="orderCountAuxText">{"A page is 250 words or fewer including numbers. Unsure of your page count?"} <span className="quoteSignInButton" onClick={(e) => transitionTo("/quote/details")}>Request a quote.</span></p>
                    <div className="orderCountInputContainer">
                      <FormTextInput placeholder={"Page Count (*)"} value={pagesCount} onChange={onChangePagesCount} />
                    </div>
                    {/* {wordCount !== '' && parseInt(wordCount, 10) < 200 && 
                <div className="orderCountWarning orderCountAuxText">Sorry, but we have a 200 word minimum per order.</div>
                } */}
                  </div>
                </div>

                <div className='quotePrimaryOptionsWrapper'>
                  <h4 className="quotePrimaryTitle">Upload the files you need translated</h4>
                  <div className="quoteDetailsFileUploaderContainer">
                    <FileUploaderButton display text="Choose Files" files={files} handleAddComment={handleAddComment} handleFiles={handleFiles} handleDeleteFile={handleDeleteFile} fontSize={windowSize.width > 1024 ? 1.1 : windowSize.width > 767 ? (windowSize.orientation === 'portrait' ? 1.6 : 1.1) : (windowSize.orientation === 'portrait' ? 5 : 1.5)} />
                  </div>
                </div>

                <div className='quotePrimaryOptionsWrapper'>
                  <h4 className="quotePrimaryTitle">General Notes <span>{`(optional)`}</span></h4>
                  <div className="orderCountContainer">
                    <p className="orderCountAuxText">Please include any notes your translation team might need including the preferred spelling for all people and places.</p>
                    <FormTextInput width={"100%"} placeholder={"Notes"} value={generalNote} onChange={setGeneralNote} />
                  </div>
                </div>

                <div>
                  {!phoneScreen && <div className="quoteSubmitButtonContainer">
                    <NewButton text="Back to Order Type" onClick={(e) => transitionTo('/order/type', e)} back={true} />
                    <NewButton text="Continue to Services" disabled={!order.type || languageFrom === '' || languageTo === '' || files.length === 0 || (certified && pagesCount === '') || (pagesCount === '') || (!certified && pagesCount === '') || files.some(file => file.status !== 'complete')} onClick={() => handleContinueToOptions()} />
                  </div>}
                </div>


              </div>
            </div>

            <div className='mainOrderSecondaryContent'>
              <div className='mainOrderSecondaryContentWrap'>
                <OrderSummary order={order} certified={certified} pagesCount={pagesCount} languageFrom={languageFrom} languageTo={languageTo} discount={order.discount ? order.discount : discount ? discount : 0} />

                <div>
                  <SecureAndPrivate order={order} certified={certified} pagesCount={pagesCount}/>
                  {phoneScreen && <div className="quoteSubmitButtonContainer">
                    <NewButton text="Back to Order Type" onClick={(e) => transitionTo('/order/type', e)} back={true} />
                    <NewButton text="Continue to Services" disabled={!order.type || languageFrom === '' || languageTo === '' || files.length === 0 || (certified && pagesCount === '') || (pagesCount === '') || (!certified && pagesCount === '') || files.some(file => file.status !== 'complete')} onClick={() => handleContinueToOptions()} />
                  </div>}
                </div>
              </div>
            </div>
          </div>
        }


      </div>
    </>
  );
}

export default OrderDocuments;